export class UpdateRunRanking {

    public productionRunId : number;

    public rank : string;

}
